var map = {
	"./symbol_0.png": 38830,
	"./symbol_1.png": 68055,
	"./symbol_10.png": 30615,
	"./symbol_11.png": 87598,
	"./symbol_12.png": 59397,
	"./symbol_13.png": 46332,
	"./symbol_14.png": 29939,
	"./symbol_15.png": 91082,
	"./symbol_16.png": 40065,
	"./symbol_17.png": 55448,
	"./symbol_2.png": 9948,
	"./symbol_3.png": 92837,
	"./symbol_4.png": 25962,
	"./symbol_5.png": 81171,
	"./symbol_6.png": 35416,
	"./symbol_7.png": 56545,
	"./symbol_8.png": 21350,
	"./symbol_9.png": 60367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89305;